import { Link, useLocation } from "wouter";
import { cn } from "../../../lib/cn";
import { FOCUS_RING } from "../../../lib/focusRing";
import { isNavActive, useNavItems } from "./useNavItems";

/**
 * Desktop nav pills in the header (lg and up), styled like TabNav's pills.
 * Text-only: at the lg breakpoint the header row is only 1024px wide, and with
 * icons the pills crowd the account controls (the name wraps).
 */
export function HeaderNav() {
  const items = useNavItems();
  const [path] = useLocation();
  if (items.length === 0) return null;
  return (
    <nav aria-label="Main" className="hidden items-center gap-0.5 lg:flex">
      {items.map((item) => {
        const active = isNavActive(item, path);
        return (
          <Link
            key={item.id}
            href={item.href}
            data-tour={`nav-${item.id}`}
            aria-current={active ? "page" : undefined}
            className={cn(
              "inline-flex items-center rounded-full px-3 py-1.5 text-sm font-medium transition",
              FOCUS_RING,
              active
                ? "bg-gradient-to-br from-sky-500 to-indigo-600 text-white shadow-soft"
                : "text-neutral-600 hover:bg-sky-50 hover:text-sky-700",
            )}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
